module.exports = __webpack_public_path__ + "assets/b101.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b101.png
// module id = 572
// module chunks = 0